import type { ReactNode } from "react";
import styles from "./PageHeader.module.css";

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  meta?: ReactNode;
  children?: ReactNode;
};

export function PageHeader({ title, subtitle, meta, children }: PageHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title} title={title}>
          {title}
        </h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {meta && <div className={styles.meta}>{meta}</div>}
      </div>
      {children}
    </div>
  );
}
